<template>
  <div>
    <h-item
      :item="item"
      :count="count"
      :dense="dense"
      @click="clicked()"
    />
    <h-modifiers
      v-model="modifiers"
      @complete="addItemWithModifiers"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ChecksMinQuantity from '@/Mixins/ChecksMinQuantity'
  import HItem from './Item'
  import HModifiers from '@/Sections/Order/Modifiers/Dialog'

  export default {
    mixins: [
      ChecksMinQuantity,
    ],

    components: {
      HItem,
      HModifiers,
    },

    props: {
      item: {
        required: true,
        type: Object,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      dense: {
        required: false,
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      modifiers: false,
    }),

    computed: {
      ...mapGetters('catalog', [
        'showModifiers',
      ]),
      ...mapGetters('orders', [
        'itemCounter',
      ]),
      count () {
        return this.itemCounter(this.item.id)
      },
    },

    methods: {
      ...mapActions('orders', [
        'addItem',
        'addItemWithModifiers',
      ]),
      clicked () {
        if (this.disabled) {
          return
        }
        this.checkMinQuantity(this.item)
        if (this.showModifiers(this.item)) {
          this.openModifiers()
          return
        }
        this.addItem(this.item)
      },
      openModifiers () {
        this.$store
          .dispatch('orders/modifiers/init', { item: this.item })
          .then(() => this.modifiers = true)
      },
    },
  }
</script>
